/**
 * EmptyState — Estado vazio centralizado
 */
import { T } from '../../styles/tokens';

interface EmptyStateProps {
  icon?: any;
  title: string;
  description?: string;
  action?: any;
  /** Estilos customizados para o container */
  style?: any;
}

export function EmptyState({ icon, title, description, action, style }: EmptyStateProps) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: T.space10, textAlign: 'center',
      ...style,
    }}>
      {icon && <div style={{ fontSize: 40, marginBottom: T.space4, opacity: 0.5 }}>{icon}</div>}
      <div style={{ fontSize: T.textLg, fontWeight: T.weightSemibold, color: T.textSecondary, marginBottom: 6 }}>{title}</div>
      {description && <div style={{ fontSize: T.textBase, color: T.textMuted, maxWidth: 360 }}>{description}</div>}
      {action && <div style={{ marginTop: T.space4 }}>{action}</div>}
    </div>
  );
}
